import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarHorizontalComponent } from './sidebar-horizontal.component';


@NgModule({
  declarations: [SidebarHorizontalComponent],
  imports: [
    RouterModule,
    CommonModule,
  ],
  exports:[SidebarHorizontalComponent]
})
export class SidebarHorizontalModule { }
